Page['meus-dados'] = () => {
	Component['section-adicionar-endereco']();

	/* Deixa inputs editáveis ao clicar em "EDITAR" */
	$(`.meus-dados-v1-basic-forms .meus-dados-v1-basic-forms-form`)
		.on('click', '.meus-dados-v1-editar-btn', function () {
			$(this).parent().find('input').removeAttr('disabled').focus();
		})

	/* Apaga item ao clicar em "REMOVER" */
	$(`.meus-dados-v1-lista-enderecos .meus-dados-v1-lista-enderecos-lista`)
		.on('click', '.meus-dados-v1-remover-btn', function () {
			$(this).closest('li').remove();
		})

	/* Envia dados de endereços cadastrados para os campos de edição ao clicar em "EDITAR" */
	const editarEnderecoFormInputs = $('.section-adicionar-endereco-v1-adicionar-endereco .section-adicionar-endereco-v1-adicionar-endereco-form').find('input, select')
	$(`.meus-dados-v1-lista-enderecos .meus-dados-v1-lista-enderecos-lista`)
		.on('click', '.meus-dados-v1-editar-btn', function () {
			const $parent = $(this).closest('li');

			/* Ativa o input */
			$parent.find('input').click();

			/*
			Cria um objeto com todos os dados do endereço selecionado
			Propriedades esperadas: rua, numero, complemento, bairro, cidade, estado, cep
			*/
			const dados = $parent
				.find('.meus-dados-v1-lista-enderecos-item-dados span[data-address]')
				.toArray()
				.reduce((obj, el) => {
					const $el = $(el)
					obj[$el.attr('data-address').split(' ').shift()] = $(el).text()
					return obj
				}, {})

			dados.index = $parent.index() + 1;

			// Preenche o formulário de adicionar endereço com os dados obtidos
			Object.entries(dados).forEach(data => {
				const key = data[0];
				const value = data[1];
				const input = editarEnderecoFormInputs.filter(`[id="${key}"]`);

				// Se for select, ele vai encontrar a <option> que tem o valor esperado e selecioná-la
				if (input.is('select')) {
					input.val(() =>
						input.find('option').filter((i, el) =>
							$(el).val().toLowerCase() == value.toLowerCase()).val())
				} else {
					input.val(value)
				}

				input.change();
			})

			editarEnderecoFormInputs.first().focus()
		})

}
